export default "__VITE_ASSET__BioEAc69__"